import React from 'react';

const LogoPracticePanther = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#4A2C5A"/>
    <path d="M14 16C14 13.7909 15.7909 12 18 12H30C32.2091 12 34 13.7909 34 16V32C34 34.2091 32.2091 36 30 36H18C15.7909 36 14 34.2091 14 32V16Z" fill="white"/>
    <circle cx="24" cy="24" r="6" fill="#4A2C5A"/>
    <path d="M21 24L23 26L27 22" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default LogoPracticePanther;
